import React, { useState } from 'react';
import { isValidNumber } from '@/common/utils/numbers';
import { Label, Input } from '@/components/FormElements';
import Notice from '@/components/Notice';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss'; // Configure the min/max values for a scale

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ScaleMinMaxFields = _ref => {
  let {
    nameSpace,
    scaleLabel,
    scaleMinKey,
    scaleMaxKey,
    scaleMax,
    scaleMin,
    scaleDataMax,
    scaleDataMin,
    forceZeroBaseline = false,
    onChange
  } = _ref;
  const scaleMinId = `${nameSpace}-min`;
  const scaleMaxId = `${nameSpace}-max`;
  const {
    0: hasScaleMinError,
    1: setHasScaleMinError
  } = useState(isValueTooHigh(scaleMin, scaleDataMin));
  const {
    0: hasScaleMaxError,
    1: setHasScaleMaxError
  } = useState(isValueTooLow(scaleMax, scaleDataMax)); // Convert a numeric string to a
  // number, allowing for deletion

  const parseNumericValue = evt => {
    const value = parseFloat(`${evt.target.value}`.trim());
    return isNaN(value) ? null : value;
  };

  return /*#__PURE__*/_jsxs("div", {
    className: parentStyles.formField__grid,
    children: [/*#__PURE__*/_jsxs(Label, {
      forInput: scaleMinId,
      text: `${scaleLabel} Minimum`,
      className: parentStyles.formField,
      caption: forceZeroBaseline ? 'Start from zero' : `Minimum value on the ${scaleLabel}`,
      children: [/*#__PURE__*/_jsx(Input, {
        id: scaleMinId,
        type: "number",
        placeholder: "0",
        defaultValue: forceZeroBaseline ? 0 : scaleMin,
        disabled: forceZeroBaseline,
        onChange: evt => {
          const update = parseNumericValue(evt);
          setHasScaleMinError(isValueTooHigh(update, scaleDataMin));
          onChange({
            [scaleMinKey]: update
          });
        }
      }), hasScaleMinError ? /*#__PURE__*/_jsx(Notice, {
        text: "Value larger than recommended and may hide results",
        type: "warning"
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    }), /*#__PURE__*/_jsxs(Label, {
      forInput: scaleMaxId,
      text: `${scaleLabel} Maximum`,
      className: parentStyles.formField,
      caption: `Maximum value on the ${scaleLabel}`,
      children: [/*#__PURE__*/_jsx(Input, {
        id: scaleMaxId,
        type: "number",
        placeholder: "100",
        defaultValue: scaleMax,
        onChange: evt => {
          const update = parseNumericValue(evt);
          setHasScaleMaxError(isValueTooLow(update, scaleDataMax));
          onChange({
            [scaleMaxKey]: update
          });
        }
      }), hasScaleMaxError ? /*#__PURE__*/_jsx(Notice, {
        text: "Value smaller than recommended and may hide results",
        type: "warning"
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    })]
  });
};

export default ScaleMinMaxFields; // Determine if a value is more than a limit

function isValueTooHigh(value) {
  let limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
  if (!isValidNumber(value) || !isValidNumber(limit)) return false;
  return value > limit;
} // Determine if a value is less than a limit


function isValueTooLow(value) {
  let limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.NEGATIVE_INFINITY;
  if (!isValidNumber(value) || !isValidNumber(limit)) return false;
  return value < limit;
}